import React, { useEffect, useState } from 'react';

import { ReactComponent as CheckGrayIcon } from '@assets/icons/check-gray.svg';
import { ReactComponent as CompletedIcon } from '@assets/icons/completed-icon.svg';

import ModalHeader from '@components/modals/ModalHeader';
import { toastError } from '@components/Toast';
import CommonImage from '@components/CommonImage';

import { renderSetImages, STATIC_SET_CONSTANTS } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

import ApiClient from '@/lib/apiClient';

const DesignOrderModal = ({ orderId, onCloseModal, setProductRefNumber = () => {} }) => {
	const [designOrder, setDesignOrder] = useState([]);
	const [searchValue, setSearchValue] = useState('');

	useEffect(() => {
		fetchOrderDesign();
	}, [orderId]);

	const fetchOrderDesign = async () => {
		try {
			const data = await ApiClient.GET(`${BASE_URL}/order/${orderId}/products-with-status`, '', true);
			setDesignOrder(data.data);
		} catch (err) {
			toastError(err.response.data.message);
		}
	};
	const clickDesign = (design) => {
		setProductRefNumber(design.referenceNumber);
		onCloseModal();
	};

	const filteredDesignOrder = designOrder.filter((design) =>
		design.referenceNumber.toLowerCase().includes(searchValue.toLowerCase())
	);

	return (
		<div className="wraper container-fluid dashboard-container">
			<div className="popup-wrapper">
				{/* supplier-upload-modal */}
				<div className="common-popup all-order-modal">
					<ModalHeader className="border-0" onClose={onCloseModal} />
					<div className="common-popup-header pt-2 border-0 d-flex justify-content-between">
						<div className="popup-tilte">
							<h3 className="medium-14 mb-0">All Designs ({designOrder?.length})</h3>
						</div>
						<div className="m-0 search-filter">
							<div className="with-icon right-icon">
								<input
									onChange={(e) => setSearchValue(e.target.value)}
									type="text"
									placeholder="Search with design no"
								/>
								<span className="right-icon">
									<img src="/icons/search.png" alt="" />
								</span>
							</div>
						</div>
					</div>
					<div className="common-popup-body pt-0">
						<div className="all-order-design">
							<div className="order-items">
								{filteredDesignOrder?.map((design) => (
									<div
										key={design.id}
										className="single-design-card"
										onClick={() => clickDesign(design)}
									>
										<div className="card-top">
											{design?.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT ? (
												renderSetImages(
													design?.setMemberList?.map((item) => ({
														image: item.image
													})),
													'100%'
												)
											) : (
												<CommonImage src={design.image} alt="" isStatic={false} />
											)}
											{design.productDraftStatus === 'COMPLETED' && (
												<div className="check-icon">
													<CompletedIcon width={24} height={24} />
												</div>
											)}
											{design.productDraftStatus === 'RUNNING' && (
												<div className="check-icon">
													<CheckGrayIcon width={24} height={24} />
												</div>
											)}
										</div>
										<div className="card-content mt-2">
											<h3 className="regular-12 gray_dark_01 design-title">
												{design.referenceNumber}
											</h3>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DesignOrderModal;
